<template>
  <div class="comp-container comp-container__user-panel POS-f TRBL-0">
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <transition
          name="animation-slide-in-top"
        >
          <div
            class="modal P-m BDRS-bl-m BDRS-br-m BGC-white"
            v-if="show"
          >
            <template v-if="isLogin">
              <div class="header MB-m TA-c">
                <div class="header__left"></div>
                <div class="header__title FW-b">{{ $t('userPanel.membership') }}</div>
                <div class="header__right" v-on:click="$emit('close')">
                  <button><span class="material-icons-round">expand_less</span></button>
                </div>
              </div>
              <div class="main MT-m MB-s">
                <div class="card POS-r MB-s BDRS-s BGC-light">
                  <div
                    class="info POS-a TRBL-0 BDRS-s BGZ-c BGP-c-c BGR-n TA-c C-white"
                    style="background-image: url(https://ocard.co:555/vip/0c343f5d9780e99143eff552aabbc4ef_m.jpg)"
                  >
                    aaa
                  </div>
                </div>
                <div class="stats">
                  <div class="stat">
                    <div class="count">
                      3
                    </div>
                    <div class="label">
                      {{ $t('userPanel.coupon') }}
                    </div>
                  </div>
                  <div class="stat">
                    <div class="count">
                      1,329
                    </div>
                    <div class="label">
                      {{ $t('userPanel.pointsNum') }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="header MB-m TA-c">
                <div class="header__left"></div>
                <div class="header__title FW-b">{{ $t('userPanel.BookNow') }}</div>
                <div class="header__right" v-on:click="$emit('close')">
                  <button><span class="material-icons-round">expand_less</span></button>
                </div>
              </div>
              <div class="main MT-m MB-s" v-if="user.logged_in" v-on:click="goVip(user.vip_url)">
                <div class="not-vip TA-c P-m">
                  <img class="avatar MT-0 MR-a MB-0 ML-a" :src="user.avatar" v-if="user.avatar">
                  <img class="avatar MT-0 MR-a MB-0 ML-a" src="@/assets/default-avatar.svg" v-else>
                  <div class="MT-s FZ-24 FW-b">{{ user.name }}</div>
                  <div class="MT-s FZ-16 FW-l">{{ user.vip.name }}</div>
                </div>
              </div>
              <div class="main MT-m MB-s" v-else>
                <template v-if="user.login_enable">
                  <div class="login-btns">
                    <button class="login-btn BGC-brand" v-on:click="goLogin()">
                      <span class="icon material-icons-round">login</span>
                      <span class="label"> {{ $t('userPanel.login') }}</span>
                    </button>
                  </div>
                </template>
              </div>
            </template>
            <div class="links">
              <a
                class="link"
                v-for="(action, index) in user.actions"
                v-bind:key="'action#' + index"
                v-on:click="goAction(action)"
              >
                <span class="icon material-icons-round">{{ parseActionIcon(action) }}</span>
                <span class="label">{{ parseActionLabel(action) }}</span>
              </a>
            </div>
            <div class="ocard MT-m TA-c FZ-12 LH-140 C-grey">
              <div class="terms MT-xxs MB-xxs">
                <a href="https://ocard.co/privacy" target="blank">{{ $t('userPanel.privacyPolicy') }}</a>・<a href="https://ocard.co/terms" target="blank">{{ $t('userPanel.terms') }}</a>
              </div>
              <div v-on:click="debug += 1">
                {{ VUE_APP_VERSION }}
              </div>
              <div v-if="debug > 4" class="debug P-s">
                <button v-on:click="showCookie()" class="MB-s">Show Cookie</button>
                <button v-on:click="masterClearUtk()" class="MB-s">Master Delete Cookie</button>
                <textarea ref="cookie" class="MB-s"></textarea>
              </div>
            </div>
            <div class="footer TA-r" v-if="footer && user.login_enable">
              <button
                class="btn MT-m PT-xs PR-m PB-xs PL-m BDRS-m BGC-light C-grey FZ-12 FW-b ACTIVE-small"
                v-if="user.logged_in"
                v-on:click="goLogout()"
              >{{ $t('userPanel.logout') }}</button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from '@/helpers/axios';
import Cookie from 'js-cookie';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      debug: 0,
      footer: Cookie.get('platform') !== 'ocard' && Cookie.get('platform') !== 'ocard_app',
    };
  },
  computed: {
    ...mapState([
      'user',
      'client',
    ]),
    VUE_APP_VERSION() {
      return this.$store.state.VUE_APP_VERSION;
    },
  },
  mounted() {
    this.show = true;
  },
  methods: {
    ...mapMutations([
      'clearUtk',
      'masterClearUtk',
    ]),
    goLogin() {
      let loginUrl = `https://api.booknow.tw/book/oauth/${this.$route.params.brandId}?`;

      loginUrl += `r=${encodeURIComponent(window.location.href)}`;
      loginUrl += '&via=booking';
      // if (this.client.ltk) {
      //   loginUrl += '&';
      //   loginUrl += `s=${this.client.ltk}`;
      // }

      window.location.href = loginUrl;
    },
    goLogout() {
      Axios({
        method: 'post',
        url: '/logout',
        data: {},
      })
        .then((response) => {
          if (response.data.code === 500) {
            this.clearUtk();
            window.location.reload(false);
          }
        });
    },
    goVip(url) {
      window.location.href = url;
    },
    parseActionIcon(action) {
      let icon;
      switch (action.type) {
        case 'ORDERS':
          icon = 'receipt_long';
          break;

        case 'QA':
          icon = 'help';
          break;

        case 'CUSTOMER_SERVICE':
          icon = 'chat_bubble';
          break;

        default:
          icon = '';
          break;
      }
      return icon;
    },
    parseActionLabel(action) {
      let label;
      switch (action.type) {
        case 'ORDERS':
          label = this.$i18n.t('userPanel.myOrders');
          break;

        case 'QA':
          label = this.$i18n.t('userPanel.faqs');
          break;

        case 'CUSTOMER_SERVICE':
          label = this.$i18n.t('userPanel.customerService');
          break;

        default:
          label = '';
          break;
      }
      return label;
    },
    goAction(action) {
      if (action.target) {
        this.$router.push({ name: action.target });
      } else if (action.url) {
        window.location.href = action.url;
      }
    },
    showCookie() {
      this.$refs.cookie.value = document.cookie;
    },
  },
};
</script>

<style lang="sass" scoped>
.comp-container__user-panel
  width: 100%
  z-index: $z-index-modal
  overflow: auto

  background-color: rgba(0, 0, 0, .25)

  user-select: none

  &::-webkit-scrollbar
    display: none

.modal
  width: 100%
  background-color: white
  border-radius: 8px
  padding: 16px

.header
  display: flex
  align-items: center

  &__left,
  &__title,
  &__right
    height: 32px

  &__left,
  &__right
    width: 32px

  &__title
    flex-grow: 1
    line-height: 32px

  button
    @extend .P-xxs
    @extend .W-xl
    @extend .H-xl

    border: none
    @extend .BDRS-s

    @extend .BGC-t

    @extend .C-grey

    appearance: none
    outline: 0

    &:active
      @extend .BGC-light

      outline: 0

.not-vip
  .avatar
    display: block
    width: 104px
    height: 104px

    border-radius: 100%

.card
  padding-top: 49.8591549%

  .info
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)

.stats
  display: flex
  justify-content: space-between

.stat
  display: flex
  flex-grow: 1
  flex-direction: column
  width: calc(50% - 4px)

  @extend .TA-c

  .count
    @extend .MT-s
    @extend .MB-s

    font-size: $size-xxl
    @extend .FW-l
    @extend .LH-100

  .label
    @extend .C-grey
    font-size: 12px

.login-btns
  display: flex
  flex-direction: column

.login-btn
  display: flex
  @extend .P-m
  @extend .MT-xxs
  @extend .MB-xxs

  border: none
  @extend .BDRS-99

  @extend .C-dark
  @extend .FW-b
  @extend .TA-c
  text-decoration: none

  @extend .ACTIVE-small

  .icon
    @extend .MR-s

  .label
    flex-grow: 1
    @extend .PR-xl

  &.is-line
    background-color: #00c300

.links
  display: flex
  flex-wrap: wrap
  justify-content: space-between

  .link
    display: flex
    width: calc(50% - 4px)
    @extend .P-m
    @extend .MT-xxs
    @extend .MB-xxs

    @extend .BDRS-m

    @extend .BGC-light

    @extend .C-grey
    @extend .FW-b
    text-decoration: none

    @extend .ACTIVE-small

    &:active
      @extend .C-dark

  .icon
    @extend .MR-s

  .label
    flex-grow: 1

.ocard
  .terms
    a
      color: currentcolor
      text-decoration: underline

.footer
  .btn
    border: none

    appearance: none
    outline: none

.debug
  *
    width: 100%
</style>
